import React from 'react'
import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <article style={{ padding: "100px" }}>
            <h1>Oops!</h1>
            <p>Pagina non disponibile</p>
            <nav>
                <Link to="/">Ritorna alla Homepage</Link>
            </nav>
        </article>
    )
}

export default Missing
